import React, { useEffect } from 'react';
import Form from '@rjsf/material-ui';
import { TextFormControl, HashCalculator, RTEFormField } from './FormControls';
import { ArrayTemplate } from './Templates';
import PropTypes from 'prop-types';
import UploadFile from './FormControls/UploadFile';

const fields = {
  TextField: TextFormControl,
  HashField: HashCalculator,
  RTEField: RTEFormField,
  UploadFile: UploadFile
};

const CustomForm = ({
  formRef,
  submitFormButton,
  onSubmit,
  onChange,
  onError,
  schema,
  uiSchema = {},
  formData,
  customFormats,
  transformErrors,
  children
}) => {
  useEffect(() => {
    if (!schema || !schema.properties || Object.keys(schema.properties).length === 0) {
      onSubmit({});
    }
  }, [schema]);

  return (
    <Form
      ref={formRef}
      noHtml5Validate
      schema={schema}
      transformErrors={transformErrors}
      fields={fields}
      ArrayFieldTemplate={ArrayTemplate}
      autoComplete='off'
      uiSchema={uiSchema}
      onSubmit={onSubmit}
      onChange={onChange}
      onError={onError}
      formData={formData}
      className='w-100'
      customFormats={customFormats}
    >
      {children || (
        <button
          ref={submitFormButton}
          type='submit'
          style={{ display: 'none' }}
        />
      )}
    </Form>
  );
};

CustomForm.propTypes = {
  formRef: PropTypes.object,
  submitFormButton: PropTypes.object,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  transformErrors: PropTypes.func,
  onError: PropTypes.any,
  schema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object,
  formData: PropTypes.object,
  customFormats: PropTypes.any,
  children: PropTypes.node
};

export default CustomForm;
